{
    "name": "i2x-coach",
    "version": "1.42.1",
    "daemonVersion": "1.8.6",
    "description": "i2x coach app",
    "author": "i2x GmbH",
    "private": true,
    "engines": {
        "node": "22.x"
    },
    "scripts": {
        "start:dev": "cross-env NODE_ENV=development PORT=3001 node scripts/esbuild/dev.mjs",
        "start:prod": "cross-env NODE_ENV=production HOST=0.0.0.0 PORT=3001 node scripts/esbuild/dev.mjs",
        "start:listener-mock": "cross-env NODE_ENV=development tsx listener-mock/listener-mock-server.ts",
        "test": "cross-env NODE_ENV=test NODE_OPTIONS=--require=./jest/require-hooks/proxy-agent-stub.cjs jest --coverage",
        "test:watch": "cross-env NODE_ENV=test NODE_OPTIONS=--require=./jest/require-hooks/proxy-agent-stub.cjs jest --watchAll --coverage",
        "test:ci": "cross-env NODE_ENV=test NODE_OPTIONS=--require=./jest/require-hooks/proxy-agent-stub.cjs jest --reporters=github-actions --ci",
        "build": "cross-env NODE_ENV=production node scripts/esbuild/build.mjs",
        "build:dev": "cross-env NODE_ENV=development node scripts/esbuild/build.mjs",
        "check:esbuild": "cross-env NODE_ENV=development node scripts/esbuild/check.mjs",
        "check:types": "tsc --noEmit",
        "check:ts-migration-guardrails": "node scripts/ci/ts-migration-guardrails.mjs",
        "check:import-smoke": "node scripts/ci/import-path-smoke.mjs",
        "check:jest-transformer": "node scripts/ci/jest-transformer-regression.mjs",
        "refactor:metrics": "bash scripts/refactor-metrics.sh src",
        "list-licenses": "license-checker --json --production",
        "check-licenses": "license-checker --production --failOn 'AGPL10;AGPL30;CCBYNC10;CCBYNC20;CCBYNC25;CCBYNC30;CCBYNC40;CCBYNCND10;CCBYNCND20;CCBYNCND25;CCBYNCND30;CCBYNCND40;CCBYNCSA10;CCBYNCSA20;CCBYNCSA25;CCBYNCSA30;CCBYNCSA40;CommonsClause;Facebook2Clause;Facebook3Clause;FacebookExamples;WTFPL;'",
        "lint": "eslint --quiet 'src/**/*.{ts,tsx}'",
        "lint:fix": "eslint --quiet --fix 'src/**/*.{ts,tsx}'"
    },
    "lint-staged": {
        "src/**/*.{ts,tsx}": "eslint",
        "./src/**/*.{ts,tsx,json,md,css}": [
            "prettier --config ./.prettierrc --write",
            "git add"
        ]
    },
    "dependencies": {
        "axios": "^1.17.0",
        "core-js": "3.6.5",
        "date-fns": "1.29.0",
        "dayjs": "^1.11.13",
        "eventemitter3": "3.1.0",
        "hyphenation.de": "^0.2.1",
        "hyphenation.en-us": "^0.2.1",
        "hypher": "^0.2.5",
        "jsonschema": "^1.4.1",
        "lodash": "~4.18.1",
        "moment": "2.29.4",
        "node-polyglot": "2.4.0",
        "opus-decoder": "^0.7.7",
        "ordinal": "^1.0.3",
        "polished": "2.2.0",
        "prop-types": "15.7.2",
        "protobufjs": "7.6.6",
        "raven-js": "3.26.4",
        "react": "16.14.0",
        "react-dom": "16.14.0",
        "react-redux": "5.1.2",
        "react-router": "^6.30.3",
        "react-router-dom": "^6.30.3",
        "react-scrollbars-custom": "^4.1.1",
        "react-select": "^5.10.2",
        "react-transition-group": "2.5.0",
        "react-virtualized": "9.20.1",
        "reactjs-popup": "^2.0.6",
        "redux": "4.0.5",
        "redux-persist": "^6.0.0",
        "redux-saga": "0.16.2",
        "redux-thunk": "2.3.0",
        "remarkable": "~2.0.1",
        "semver": "~7.7.2",
        "styled-components": "~6.1.1",
        "url": "^0.11.4",
        "uuid": "^14.0.0",
        "validator": "~13.15.26",
        "ws": "^8.21.0"
    },
    "devDependencies": {
        "@eslint/js": "^9.35.0",
        "@testing-library/jest-dom": "^5.17.0",
        "@testing-library/react": "^12.1.5",
        "@testing-library/user-event": "^13.5.0",
        "@types/jest": "29.5.11",
        "@types/lodash": "^4.17.24",
        "@types/node": "22.20.5",
        "@types/node-polyglot": "^2.5.0",
        "@types/react": "16.14.66",
        "@types/react-dom": "16.9.25",
        "@types/react-redux": "~5.0.28",
        "@types/react-virtualized": "^9.22.3",
        "@types/remarkable": "^2.0.8",
        "@types/semver": "^7.7.1",
        "@types/ws": "^8.5.3",
        "cross-env": "7.0.2",
        "dotenv": "16.0.1",
        "esbuild": "^0.25.10",
        "eslint": "^9.35.0",
        "eslint-config-prettier": "^10.1.8",
        "eslint-plugin-prettier": "^5.5.4",
        "eslint-plugin-react": "^7.37.5",
        "globals": "^16.3.0",
        "jest": "29.7.0",
        "jest-environment-jsdom": "29.7.0",
        "license-checker": "^25.0.1",
        "lint-staged": "^16.1.6",
        "prettier": "~3.6.2",
        "protobufjs-cli": "^1.1.2",
        "ts-proto": "^1.115.5",
        "tsx": "~4.20.5",
        "typescript": "^4.9.5",
        "typescript-eslint": "^8.43.0",
        "wavefile": "11.0.0"
    },
    "overrides": {
        "@types/react": "16.14.66",
        "@types/react-dom": "16.9.25"
    }
}
